(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
function initIsallyMotion(scope = document) {
 const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
 scope.querySelectorAll('[data-isally-motion]').forEach(wrapper => {
  if (wrapper.dataset.motionReady) return;
  wrapper.dataset.motionReady = 'true';
  const video = wrapper.querySelector('video');
  const button = wrapper.querySelector('button');
  if (!video || !button) return;
  const fallback = () => wrapper.removeAttribute('data-playing');
  const playing = () => {
   if (reduce.matches) { video.pause(); return; }
   wrapper.setAttribute('data-playing', '');
   button.hidden = false;
   button.textContent = button.dataset.pauseLabel;
  };
  const attempt = () => {
   if (reduce.matches || !wrapper.getClientRects().length) { video.pause(); fallback(); return; }
   video.muted = true;
   video.defaultMuted = true;
   video.playsInline = true;
   video.play().catch(fallback);
  };
  video.addEventListener('playing', playing);
  video.addEventListener('pause', () => { fallback(); button.textContent = button.dataset.playLabel; });
  video.addEventListener('error', fallback);
  video.addEventListener('canplay', attempt, { once: true });
  button.addEventListener('click', () => { if (video.paused) attempt(); else video.pause(); });
  reduce.addEventListener('change', () => { button.hidden = reduce.matches; attempt(); });
  if (!video.paused && !reduce.matches) playing();
  attempt();
 });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initIsallyMotion());
else initIsallyMotion();
document.addEventListener('shopify:section:load', event => initIsallyMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
